// Guardian AI Trust Score Service Protocol Definitions
// Trust score calculation, risk assessment, and verification
//
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/trust/trust.proto (package guardianai.v1.trust, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/trust/trust.proto.
 */
export const file_guardianai_v1_trust_trust: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.trust.TrustScoreRequest
 */
export type TrustScoreRequest = Message<"guardianai.v1.trust.TrustScoreRequest"> & {
  /**
   * Email or identifier
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * USER, BUSINESS, etc.
   *
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * @generated from message guardianai.v1.trust.TrustScoreRequest
 */
export type TrustScoreRequestJson = {
  /**
   * Email or identifier
   *
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * USER, BUSINESS, etc.
   *
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;
};

/**
 * Describes the message guardianai.v1.trust.TrustScoreRequest.
 * Use `create(TrustScoreRequestSchema)` to create a new message.
 */
export const TrustScoreRequestSchema: GenMessage<TrustScoreRequest, {jsonType: TrustScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 0);

/**
 * @generated from message guardianai.v1.trust.TrustScoreReport
 */
export type TrustScoreReport = Message<"guardianai.v1.trust.TrustScoreReport"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: double trust_score = 3;
   */
  trustScore: number;

  /**
   * @generated from field: double confidence_score = 4;
   */
  confidenceScore: number;

  /**
   * @generated from field: repeated string risk_factors = 5;
   */
  riskFactors: string[];

  /**
   * @generated from field: string model_version = 6;
   */
  modelVersion: string;

  /**
   * @generated from field: string explainability = 7;
   */
  explainability: string;

  /**
   * @generated from field: guardianai.v1.trust.SocialMediaAnalysis social_media_analysis = 8;
   */
  socialMediaAnalysis?: SocialMediaAnalysis;

  /**
   * @generated from field: map<string, string> web_presence_data = 9;
   */
  webPresenceData: { [key: string]: string };

  /**
   * @generated from field: repeated string recommendations = 10;
   */
  recommendations: string[];

  /**
   * @generated from field: string verification_status = 11;
   */
  verificationStatus: string;
};

/**
 * @generated from message guardianai.v1.trust.TrustScoreReport
 */
export type TrustScoreReportJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * @generated from field: double trust_score = 3;
   */
  trustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double confidence_score = 4;
   */
  confidenceScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated string risk_factors = 5;
   */
  riskFactors?: string[];

  /**
   * @generated from field: string model_version = 6;
   */
  modelVersion?: string;

  /**
   * @generated from field: string explainability = 7;
   */
  explainability?: string;

  /**
   * @generated from field: guardianai.v1.trust.SocialMediaAnalysis social_media_analysis = 8;
   */
  socialMediaAnalysis?: SocialMediaAnalysisJson;

  /**
   * @generated from field: map<string, string> web_presence_data = 9;
   */
  webPresenceData?: { [key: string]: string };

  /**
   * @generated from field: repeated string recommendations = 10;
   */
  recommendations?: string[];

  /**
   * @generated from field: string verification_status = 11;
   */
  verificationStatus?: string;
};

/**
 * Describes the message guardianai.v1.trust.TrustScoreReport.
 * Use `create(TrustScoreReportSchema)` to create a new message.
 */
export const TrustScoreReportSchema: GenMessage<TrustScoreReport, {jsonType: TrustScoreReportJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 1);

/**
 * @generated from message guardianai.v1.trust.SocialMediaAnalysis
 */
export type SocialMediaAnalysis = Message<"guardianai.v1.trust.SocialMediaAnalysis"> & {
  /**
   * @generated from field: bool has_social_media = 1;
   */
  hasSocialMedia: boolean;

  /**
   * @generated from field: int32 platform_count = 2;
   */
  platformCount: number;

  /**
   * @generated from field: int32 verified_accounts = 3;
   */
  verifiedAccounts: number;

  /**
   * @generated from field: int32 total_followers = 4;
   */
  totalFollowers: number;

  /**
   * @generated from field: string risk_level = 5;
   */
  riskLevel: string;

  /**
   * @generated from field: map<string, guardianai.v1.trust.SocialMediaProfile> platforms = 6;
   */
  platforms: { [key: string]: SocialMediaProfile };
};

/**
 * @generated from message guardianai.v1.trust.SocialMediaAnalysis
 */
export type SocialMediaAnalysisJson = {
  /**
   * @generated from field: bool has_social_media = 1;
   */
  hasSocialMedia?: boolean;

  /**
   * @generated from field: int32 platform_count = 2;
   */
  platformCount?: number;

  /**
   * @generated from field: int32 verified_accounts = 3;
   */
  verifiedAccounts?: number;

  /**
   * @generated from field: int32 total_followers = 4;
   */
  totalFollowers?: number;

  /**
   * @generated from field: string risk_level = 5;
   */
  riskLevel?: string;

  /**
   * @generated from field: map<string, guardianai.v1.trust.SocialMediaProfile> platforms = 6;
   */
  platforms?: { [key: string]: SocialMediaProfileJson };
};

/**
 * Describes the message guardianai.v1.trust.SocialMediaAnalysis.
 * Use `create(SocialMediaAnalysisSchema)` to create a new message.
 */
export const SocialMediaAnalysisSchema: GenMessage<SocialMediaAnalysis, {jsonType: SocialMediaAnalysisJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 2);

/**
 * @generated from message guardianai.v1.trust.SocialMediaProfile
 */
export type SocialMediaProfile = Message<"guardianai.v1.trust.SocialMediaProfile"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bool verified = 3;
   */
  verified: boolean;

  /**
   * @generated from field: int32 followers_count = 4;
   */
  followersCount: number;

  /**
   * @generated from field: string account_age = 5;
   */
  accountAge: string;

  /**
   * @generated from field: string last_activity = 6;
   */
  lastActivity: string;

  /**
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.trust.SocialMediaProfile
 */
export type SocialMediaProfileJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;

  /**
   * @generated from field: string username = 2;
   */
  username?: string;

  /**
   * @generated from field: bool verified = 3;
   */
  verified?: boolean;

  /**
   * @generated from field: int32 followers_count = 4;
   */
  followersCount?: number;

  /**
   * @generated from field: string account_age = 5;
   */
  accountAge?: string;

  /**
   * @generated from field: string last_activity = 6;
   */
  lastActivity?: string;

  /**
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.trust.SocialMediaProfile.
 * Use `create(SocialMediaProfileSchema)` to create a new message.
 */
export const SocialMediaProfileSchema: GenMessage<SocialMediaProfile, {jsonType: SocialMediaProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 3);

/**
 * @generated from message guardianai.v1.trust.ConfidenceScoreRequest
 */
export type ConfidenceScoreRequest = Message<"guardianai.v1.trust.ConfidenceScoreRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * @generated from message guardianai.v1.trust.ConfidenceScoreRequest
 */
export type ConfidenceScoreRequestJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;
};

/**
 * Describes the message guardianai.v1.trust.ConfidenceScoreRequest.
 * Use `create(ConfidenceScoreRequestSchema)` to create a new message.
 */
export const ConfidenceScoreRequestSchema: GenMessage<ConfidenceScoreRequest, {jsonType: ConfidenceScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 4);

/**
 * @generated from message guardianai.v1.trust.ConfidenceScoreResponse
 */
export type ConfidenceScoreResponse = Message<"guardianai.v1.trust.ConfidenceScoreResponse"> & {
  /**
   * @generated from field: double confidence_score = 1;
   */
  confidenceScore: number;
};

/**
 * @generated from message guardianai.v1.trust.ConfidenceScoreResponse
 */
export type ConfidenceScoreResponseJson = {
  /**
   * @generated from field: double confidence_score = 1;
   */
  confidenceScore?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.trust.ConfidenceScoreResponse.
 * Use `create(ConfidenceScoreResponseSchema)` to create a new message.
 */
export const ConfidenceScoreResponseSchema: GenMessage<ConfidenceScoreResponse, {jsonType: ConfidenceScoreResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 5);

/**
 * @generated from message guardianai.v1.trust.RiskFactorsRequest
 */
export type RiskFactorsRequest = Message<"guardianai.v1.trust.RiskFactorsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;
};

/**
 * @generated from message guardianai.v1.trust.RiskFactorsRequest
 */
export type RiskFactorsRequestJson = {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;
};

/**
 * Describes the message guardianai.v1.trust.RiskFactorsRequest.
 * Use `create(RiskFactorsRequestSchema)` to create a new message.
 */
export const RiskFactorsRequestSchema: GenMessage<RiskFactorsRequest, {jsonType: RiskFactorsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 6);

/**
 * @generated from message guardianai.v1.trust.RiskFactorsResponse
 */
export type RiskFactorsResponse = Message<"guardianai.v1.trust.RiskFactorsResponse"> & {
  /**
   * @generated from field: repeated string risk_factors = 1;
   */
  riskFactors: string[];
};

/**
 * @generated from message guardianai.v1.trust.RiskFactorsResponse
 */
export type RiskFactorsResponseJson = {
  /**
   * @generated from field: repeated string risk_factors = 1;
   */
  riskFactors?: string[];
};

/**
 * Describes the message guardianai.v1.trust.RiskFactorsResponse.
 * Use `create(RiskFactorsResponseSchema)` to create a new message.
 */
export const RiskFactorsResponseSchema: GenMessage<RiskFactorsResponse, {jsonType: RiskFactorsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 7);

/**
 * @generated from message guardianai.v1.trust.CalculateTrustScoreRequest
 */
export type CalculateTrustScoreRequest = Message<"guardianai.v1.trust.CalculateTrustScoreRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.trust.CalculateTrustScoreRequest
 */
export type CalculateTrustScoreRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.trust.CalculateTrustScoreRequest.
 * Use `create(CalculateTrustScoreRequestSchema)` to create a new message.
 */
export const CalculateTrustScoreRequestSchema: GenMessage<CalculateTrustScoreRequest, {jsonType: CalculateTrustScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 8);

/**
 * @generated from message guardianai.v1.trust.GetCachedScoreRequest
 */
export type GetCachedScoreRequest = Message<"guardianai.v1.trust.GetCachedScoreRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.trust.GetCachedScoreRequest
 */
export type GetCachedScoreRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.trust.GetCachedScoreRequest.
 * Use `create(GetCachedScoreRequestSchema)` to create a new message.
 */
export const GetCachedScoreRequestSchema: GenMessage<GetCachedScoreRequest, {jsonType: GetCachedScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 9);

/**
 * @generated from message guardianai.v1.trust.RecalculateScoreRequest
 */
export type RecalculateScoreRequest = Message<"guardianai.v1.trust.RecalculateScoreRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.trust.RecalculateScoreRequest
 */
export type RecalculateScoreRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.trust.RecalculateScoreRequest.
 * Use `create(RecalculateScoreRequestSchema)` to create a new message.
 */
export const RecalculateScoreRequestSchema: GenMessage<RecalculateScoreRequest, {jsonType: RecalculateScoreRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 10);

/**
 * @generated from message guardianai.v1.trust.GetFactorBreakdownRequest
 */
export type GetFactorBreakdownRequest = Message<"guardianai.v1.trust.GetFactorBreakdownRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.trust.GetFactorBreakdownRequest
 */
export type GetFactorBreakdownRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.trust.GetFactorBreakdownRequest.
 * Use `create(GetFactorBreakdownRequestSchema)` to create a new message.
 */
export const GetFactorBreakdownRequestSchema: GenMessage<GetFactorBreakdownRequest, {jsonType: GetFactorBreakdownRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 11);

/**
 * @generated from message guardianai.v1.trust.GetScoreHistoryRequest
 */
export type GetScoreHistoryRequest = Message<"guardianai.v1.trust.GetScoreHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.trust.GetScoreHistoryRequest
 */
export type GetScoreHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.trust.GetScoreHistoryRequest.
 * Use `create(GetScoreHistoryRequestSchema)` to create a new message.
 */
export const GetScoreHistoryRequestSchema: GenMessage<GetScoreHistoryRequest, {jsonType: GetScoreHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 12);

/**
 * @generated from message guardianai.v1.trust.BatchCalculateRequest
 */
export type BatchCalculateRequest = Message<"guardianai.v1.trust.BatchCalculateRequest"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];
};

/**
 * @generated from message guardianai.v1.trust.BatchCalculateRequest
 */
export type BatchCalculateRequestJson = {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds?: string[];
};

/**
 * Describes the message guardianai.v1.trust.BatchCalculateRequest.
 * Use `create(BatchCalculateRequestSchema)` to create a new message.
 */
export const BatchCalculateRequestSchema: GenMessage<BatchCalculateRequest, {jsonType: BatchCalculateRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 13);

/**
 * @generated from message guardianai.v1.trust.TrustScoreResponse
 */
export type TrustScoreResponse = Message<"guardianai.v1.trust.TrustScoreResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: double overall_score = 2;
   */
  overallScore: number;

  /**
   * @generated from field: double confidence = 3;
   */
  confidence: number;

  /**
   * @generated from field: repeated guardianai.v1.trust.FactorScore factors = 4;
   */
  factors: FactorScore[];

  /**
   * @generated from field: string risk_level = 5;
   */
  riskLevel: string;

  /**
   * @generated from field: int64 calculated_at = 6;
   */
  calculatedAt: bigint;

  /**
   * @generated from field: int64 expires_at = 7;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.trust.TrustScoreResponse
 */
export type TrustScoreResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: double overall_score = 2;
   */
  overallScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double confidence = 3;
   */
  confidence?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated guardianai.v1.trust.FactorScore factors = 4;
   */
  factors?: FactorScoreJson[];

  /**
   * @generated from field: string risk_level = 5;
   */
  riskLevel?: string;

  /**
   * @generated from field: int64 calculated_at = 6;
   */
  calculatedAt?: string;

  /**
   * @generated from field: int64 expires_at = 7;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.trust.TrustScoreResponse.
 * Use `create(TrustScoreResponseSchema)` to create a new message.
 */
export const TrustScoreResponseSchema: GenMessage<TrustScoreResponse, {jsonType: TrustScoreResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 14);

/**
 * @generated from message guardianai.v1.trust.FactorScore
 */
export type FactorScore = Message<"guardianai.v1.trust.FactorScore"> & {
  /**
   * @generated from field: string factor = 1;
   */
  factor: string;

  /**
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * @generated from field: double weight = 3;
   */
  weight: number;

  /**
   * @generated from field: double contribution = 4;
   */
  contribution: number;

  /**
   * @generated from field: string explanation = 5;
   */
  explanation: string;
};

/**
 * @generated from message guardianai.v1.trust.FactorScore
 */
export type FactorScoreJson = {
  /**
   * @generated from field: string factor = 1;
   */
  factor?: string;

  /**
   * @generated from field: double score = 2;
   */
  score?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double weight = 3;
   */
  weight?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double contribution = 4;
   */
  contribution?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string explanation = 5;
   */
  explanation?: string;
};

/**
 * Describes the message guardianai.v1.trust.FactorScore.
 * Use `create(FactorScoreSchema)` to create a new message.
 */
export const FactorScoreSchema: GenMessage<FactorScore, {jsonType: FactorScoreJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 15);

/**
 * @generated from message guardianai.v1.trust.FactorBreakdownResponse
 */
export type FactorBreakdownResponse = Message<"guardianai.v1.trust.FactorBreakdownResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: repeated guardianai.v1.trust.FactorScore factors = 2;
   */
  factors: FactorScore[];
};

/**
 * @generated from message guardianai.v1.trust.FactorBreakdownResponse
 */
export type FactorBreakdownResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: repeated guardianai.v1.trust.FactorScore factors = 2;
   */
  factors?: FactorScoreJson[];
};

/**
 * Describes the message guardianai.v1.trust.FactorBreakdownResponse.
 * Use `create(FactorBreakdownResponseSchema)` to create a new message.
 */
export const FactorBreakdownResponseSchema: GenMessage<FactorBreakdownResponse, {jsonType: FactorBreakdownResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 16);

/**
 * @generated from message guardianai.v1.trust.ScoreHistoryResponse
 */
export type ScoreHistoryResponse = Message<"guardianai.v1.trust.ScoreHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.trust.TrustScoreResponse scores = 1;
   */
  scores: TrustScoreResponse[];
};

/**
 * @generated from message guardianai.v1.trust.ScoreHistoryResponse
 */
export type ScoreHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.trust.TrustScoreResponse scores = 1;
   */
  scores?: TrustScoreResponseJson[];
};

/**
 * Describes the message guardianai.v1.trust.ScoreHistoryResponse.
 * Use `create(ScoreHistoryResponseSchema)` to create a new message.
 */
export const ScoreHistoryResponseSchema: GenMessage<ScoreHistoryResponse, {jsonType: ScoreHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 17);

/**
 * @generated from message guardianai.v1.trust.BatchCalculateResponse
 */
export type BatchCalculateResponse = Message<"guardianai.v1.trust.BatchCalculateResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.trust.TrustScoreResponse scores = 1;
   */
  scores: TrustScoreResponse[];

  /**
   * @generated from field: int32 success_count = 2;
   */
  successCount: number;

  /**
   * @generated from field: int32 failure_count = 3;
   */
  failureCount: number;
};

/**
 * @generated from message guardianai.v1.trust.BatchCalculateResponse
 */
export type BatchCalculateResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.trust.TrustScoreResponse scores = 1;
   */
  scores?: TrustScoreResponseJson[];

  /**
   * @generated from field: int32 success_count = 2;
   */
  successCount?: number;

  /**
   * @generated from field: int32 failure_count = 3;
   */
  failureCount?: number;
};

/**
 * Describes the message guardianai.v1.trust.BatchCalculateResponse.
 * Use `create(BatchCalculateResponseSchema)` to create a new message.
 */
export const BatchCalculateResponseSchema: GenMessage<BatchCalculateResponse, {jsonType: BatchCalculateResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_trust_trust, 18);

/**
 * Trust Score Service - Calculate and retrieve trust scores
 *
 * @generated from service guardianai.v1.trust.TrustScoreService
 */
export const TrustScoreService: GenService<{
  /**
   * Pre-registration trust scan for new users
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.PreRegistrationScan
   */
  preRegistrationScan: {
    methodKind: "unary";
    input: typeof TrustScoreRequestSchema;
    output: typeof TrustScoreReportSchema;
  },
  /**
   * Post-registration deep trust scan
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.PostRegistrationScan
   */
  postRegistrationScan: {
    methodKind: "unary";
    input: typeof TrustScoreRequestSchema;
    output: typeof TrustScoreReportSchema;
  },
  /**
   * Calculate trust score
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.CalculateTrustScore
   */
  calculateTrustScore: {
    methodKind: "unary";
    input: typeof CalculateTrustScoreRequestSchema;
    output: typeof TrustScoreResponseSchema;
  },
  /**
   * Get cached score if available
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.GetCachedScore
   */
  getCachedScore: {
    methodKind: "unary";
    input: typeof GetCachedScoreRequestSchema;
    output: typeof TrustScoreResponseSchema;
  },
  /**
   * Force recalculation
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.RecalculateScore
   */
  recalculateScore: {
    methodKind: "unary";
    input: typeof RecalculateScoreRequestSchema;
    output: typeof TrustScoreResponseSchema;
  },
  /**
   * Get factor breakdown
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.GetFactorBreakdown
   */
  getFactorBreakdown: {
    methodKind: "unary";
    input: typeof GetFactorBreakdownRequestSchema;
    output: typeof FactorBreakdownResponseSchema;
  },
  /**
   * Get score history
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.GetScoreHistory
   */
  getScoreHistory: {
    methodKind: "unary";
    input: typeof GetScoreHistoryRequestSchema;
    output: typeof ScoreHistoryResponseSchema;
  },
  /**
   * Batch calculation
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.BatchCalculate
   */
  batchCalculate: {
    methodKind: "unary";
    input: typeof BatchCalculateRequestSchema;
    output: typeof BatchCalculateResponseSchema;
  },
  /**
   * Get confidence score
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.GetConfidenceScore
   */
  getConfidenceScore: {
    methodKind: "unary";
    input: typeof ConfidenceScoreRequestSchema;
    output: typeof ConfidenceScoreResponseSchema;
  },
  /**
   * Get top risk factors
   *
   * @generated from rpc guardianai.v1.trust.TrustScoreService.GetTopRiskFactors
   */
  getTopRiskFactors: {
    methodKind: "unary";
    input: typeof RiskFactorsRequestSchema;
    output: typeof RiskFactorsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_trust_trust, 0);

